import { Reducer } from 'redux';

import { ApplicantOfferStatus, ITag, IStudentRow } from 'api-paths-cas';
import { toast } from 'react-toastify';
import { DashboardActionTypes, DashboardState } from './types';

import { UIActionTypes } from '../ui/types';
import { studentToRow, updateStudentPartners } from './helpers';

const defaultFilterOptions = {
  agent: [],
  courses: [],
  immigrationProvider: [],
  nationality: [],
  partner: [],
  pathway: [],
  residency: [],
  riskRegion: [],
  tag: [],
  uni: [],
};

const initialState: DashboardState = {
  allStudentsSelected: false,
  openedStudentRecords: [],
  resetDropdownStatus: false,
  isDropdownDisabled: true,
  filters: [],
  isFiltersVisible: false,
  allStudentsLoaded: false,
  selectedRows: [],
  isTaskBarOpened: false,
  tabs: [],
  totals: undefined,
  students: undefined,
  filterOptionsLoading: false,
  filterOptions: defaultFilterOptions,
  allSelected: false,
  selectedPartnersTotals: null,
  selectedPartnersLoading: false,
  selectedTagsTotals: null,
  selectedTagsLoaded: false,
  sitsTransferResponse: null,
};

const reducer: Reducer<DashboardState> = (state = initialState, action: any): DashboardState => {
  switch (action.type) {
    case DashboardActionTypes.CLEAR_STUDENTS: {
      return {
        ...state,
        allStudentsLoaded: false,
        students: [],
      };
    }
    case DashboardActionTypes.GET_STUDENTS: {
      return {
        ...state,
        allStudentsLoaded: false,
      };
    }
    case DashboardActionTypes.GET_STUDENTS_SUCCESS: {
      const newStudents = action.payload.students.map((doc: any) =>
        studentToRow(doc, action.payload.auth, action.payload.config),
      ) as IStudentRow[];

      return {
        ...state,
        allStudentsLoaded: true,
        students: newStudents,
      };
    }

    case DashboardActionTypes.GET_TOTALS_SUCCESS: {
      return {
        ...state,
        totals: action.payload.totals,
      };
    }

    case DashboardActionTypes.GET_STUDENTS_FAILURE: {
      return {
        ...state,
        allStudentsLoaded: false,
      };
    }
    case DashboardActionTypes.CLEAR_OPENED_RECORDS: {
      return {
        ...state,
        openedStudentRecords: [],
      };
    }

    case DashboardActionTypes.OPENED_STUDENT_RECORDS: {
      const { action: serverAction, subject: studentNumber, data } = JSON.parse(action.payload.data);
      const parsedData = JSON.parse(data);
      const { user: userName, status } = parsedData;
      const newOpeneStudentRecords = [...state.openedStudentRecords];
      if (serverAction === 'student-opened') {
        const foundKey = newOpeneStudentRecords.find(
          studentRec => studentRec.studentNumber === studentNumber && studentRec.userName === userName,
        );
        if (!foundKey) {
          newOpeneStudentRecords.push({ studentNumber, userName, status });
        }
      } else if (serverAction === 'student-closed') {
        const index = newOpeneStudentRecords.findIndex(
          studentRec => studentRec.studentNumber === studentNumber && studentRec.userName === userName,
        );
        if (index !== -1) {
          newOpeneStudentRecords.splice(index, 1);
        }
      }
      return {
        ...state,
        openedStudentRecords: [...newOpeneStudentRecords],
      };
    }
    case DashboardActionTypes.STUDENT_ASSIGN_VISA_SUPPORT: {
      const { uni, studentNo, intakeId, offerId } = action.payload;
      const index = state.students?.findIndex(doc => doc.p_key === `${uni}#${studentNo}#${intakeId}#${offerId}`);
      if (index > -1) {
        return {
          ...state,
          students: [
            ...state.students.slice(0, index),
            { ...state.students[index], visaSupport: true },
            ...state.students.slice(index + 1),
          ],
        };
      }
      return state;
    }
    case DashboardActionTypes.STUDENT_ASSIGN_VISA_SUPPORT_SUCCESS: {
      toast.success(`Successfully assigned student for Visa Support`);
      return state;
    }
    case DashboardActionTypes.STUDENT_ASSIGN_VISA_SUPPORT_FAILURE: {
      toast.error(`Failed to assign student for Visa Support: ${action.payload}`);
      return state;
    }
    case DashboardActionTypes.STUDENT_UNASSIGN_VISA_SUPPORT: {
      const { uni, studentNo, intakeId, offerId } = action.payload;
      const index = state.students?.findIndex(doc => doc.p_key === `${uni}#${studentNo}#${intakeId}#${offerId}`);
      if (index > -1) {
        return {
          ...state,
          students: [
            ...state.students.slice(0, index),
            { ...state.students[index], visaSupport: false },
            ...state.students.slice(index + 1),
          ],
        };
      }
      return state;
    }
    case DashboardActionTypes.STUDENT_UNASSIGN_VISA_SUPPORT_SUCCESS: {
      toast.success(`Successfully unassigned student from Visa Support`);
      return state;
    }
    case DashboardActionTypes.STUDENT_UNASSIGN_VISA_SUPPORT_FAILURE: {
      toast.error(`Failed to unassign student from Visa Support: ${action.payload}`);
      return state;
    }
    case DashboardActionTypes.REQUEST_SCHEDULED_INTERVIEW: {
      const studentIds = action.payload.students;
      console.log('🎯 REQUEST_SCHEDULED_INTERVIEW reducer hit!');
      console.log('studentIds:', studentIds);
      console.log('state.students count:', state.students?.length);

      const updatedStudents = state.students?.map(student => {
        const shouldUpdate = studentIds.includes(student.p_key);
        if (shouldUpdate) {
          console.log(
            '✅ Updating student:',
            student.p_key,
            'from',
            student.calendlyInterviewsInfoStatus,
            'to INVITED',
          );
        }
        if (shouldUpdate) {
          return {
            ...student,
            calendlyInterviewsInfoStatus: 'INVITED',
          };
        }
        return student;
      });

      console.log('updatedStudents count:', updatedStudents?.length);
      return {
        ...state,
        students: updatedStudents,
      };
    }
    case DashboardActionTypes.REQUEST_SCHEDULED_INTERVIEW_SUCCESS: {
      toast.success(`Successfully requested scheduled interview(s)`);
      return state;
    }
    case DashboardActionTypes.REQUEST_SCHEDULED_INTERVIEW_FAILURE: {
      toast.error(`Failed to request scheduled interview(s): ${action.payload}`);
      return state;
    }
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW: {
      const { uni, studentNo, intakeId, offerId } = action.payload;
      const studentId = `${uni}#${studentNo}#${intakeId}#${offerId}`;
      console.log('🔍 CANCEL_SCHEDULED_INTERVIEW reducer hit (single student)!');
      console.log('studentId:', studentId);

      const updatedStudents = state.students?.map(student => {
        if (student.p_key === studentId) {
          console.log('✅ Updating student:', student.p_key, 'from', student.calendlyInterviewsInfoStatus, 'to NONE');
          return {
            ...student,
            calendlyInterviewsInfoStatus: 'NONE',
          };
        }
        return student;
      });

      return {
        ...state,
        students: updatedStudents,
      };
    }
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_SUCCESS: {
      toast.success(`Successfully cancelled the interview`);
      return {
        ...state,
        selectedRows: [],
      };
    }
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_BULK: {
      const studentIds = action.payload.students;

      const updatedStudents = state.students?.map(student => {
        const shouldUpdate = studentIds.includes(student.p_key);
        if (shouldUpdate) {
          console.log('✅ Updating student:', student.p_key, 'from', student.calendlyInterviewsInfoStatus, 'to NONE');
        }
        if (shouldUpdate) {
          return {
            ...student,
            calendlyInterviewsInfoStatus: 'NONE',
          };
        }
        return student;
      });

      // console.log('updatedStudents count:', updatedStudents?.length);
      return {
        ...state,
        students: updatedStudents,
      };
    }

    case DashboardActionTypes.CANCEL_RECORDED_INTERVIEW: {
      const { uni, studentNo, intakeId, offerId } = action.payload;
      const studentId = `${uni}#${studentNo}#${intakeId}#${offerId}`;

      const updatedStudents = state.students?.map(student => {
        if (student.p_key === studentId) {
          // console.log('✅ Updating student:', student.p_key, 'from', student.recordedInterviewSystemStatus, 'to NONE');
          return {
            ...student,
            recordedInterviewSystemStatus: 'NONE',
          };
        }
        return student;
      });

      return {
        ...state,
        students: updatedStudents,
      };
    }

    case DashboardActionTypes.CANCEL_RECORDED_INTERVIEW_BULK: {
      const studentIds = action.payload.students;
      console.log('🎬 CANCEL_RECORDED_INTERVIEW_BULK reducer hit!');
      console.log('studentIds:', studentIds);
      console.log('state.students count:', state.students?.length);

      const updatedStudents = state.students?.map(student => {
        const shouldUpdate = studentIds.includes(student.p_key);
        if (shouldUpdate) {
          console.log('✅ Updating student:', student.p_key, 'from', student.recordedInterviewSystemStatus, 'to NONE');
        }
        if (shouldUpdate) {
          return {
            ...student,
            recordedInterviewSystemStatus: 'NONE',
          };
        }
        return student;
      });

      console.log('updatedStudents count:', updatedStudents?.length);
      return {
        ...state,
        students: updatedStudents,
      };
    }
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_BULK_SUCCESS: {
      toast.success(`Successfully cancelled the interview(s)`);
      return {
        ...state,
        selectedRows: [],
      };
    }
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_FAILURE: {
      toast.error(`Failed to cancel a scheduled interview: ${action.payload}`);
      return state;
    }
    case DashboardActionTypes.CANCEL_SCHEDULED_INTERVIEW_BULK_FAILURE: {
      toast.error(`Failed to cancel scheduled interview(s)`);
      return state;
    }
    case DashboardActionTypes.REQUEST_RECORDED_INTERVIEW_BULK_SUCCESS: {
      toast.success(`Successfully requested recorded interview(s)`);
      return state;
    }
    case DashboardActionTypes.REQUEST_RECORDED_INTERVIEW_BULK_FAILURE: {
      toast.error(`Failed to request recorded interview(s): ${action.payload}`);
      return state;
    }

    case DashboardActionTypes.UPDATE_STUDENT: {
      const index =
        state.students && state.students.length
          ? state.students.findIndex(doc => doc.p_key === action.payload.student.p_key)
          : -1;
      if (index > -1) {
        const oldStudent = state.students[index];
        const newStudent = studentToRow(
          action.payload.student,
          action.payload.auth,
          action.payload.config,
        ) as IStudentRow;
        console.log('🔄 UPDATE_STUDENT via WebSocket for:', action.payload.student.p_key);
        console.log('Old calendlyInterviewsInfoStatus:', oldStudent.calendlyInterviewsInfoStatus);
        console.log('New calendlyInterviewsInfoStatus:', newStudent.calendlyInterviewsInfoStatus);

        return {
          ...state,
          students: state.students
            ? [...state.students.slice(0, index), newStudent, ...state.students.slice(index + 1, state.students.length)]
            : [newStudent],
        };
      }
      return state;
    }
    case DashboardActionTypes.STUDENTS_SERVICES_REMOVE_SUCCESS:
    case DashboardActionTypes.STUDENTS_SERVICES_ADD_SUCCESS: {
      const studentNumbers = Object.keys(action.payload.data?.partners || {});

      for (const studentNumber of studentNumbers) {
        const student = state.students?.find(student => student.p_key === studentNumber);
        if (student) {
          student.partners = action.payload.data.partners[studentNumber].partners;
        }
      }

      return {
        ...state,
        students: [...(state.students || [])],
      };
    }
    case DashboardActionTypes.STUDENTS_IMMIGRATION_PROVIDER_ADD_SUCCESS:
    case DashboardActionTypes.STUDENTS_IMMIGRATION_PROVIDER_REMOVE_SUCCESS: {
      const studentNumbers = Object.keys(action.payload.data?.immigrationProviders || {});

      for (const studentNumber of studentNumbers) {
        const student = state.students?.find(student => student.p_key === studentNumber);
        if (student) {
          student.immigrationProviders = action.payload.data.immigrationProviders[studentNumber].immigrationProviders;
        }
      }

      return {
        ...state,
        students: [...(state.students || [])],
      };
    }
    case DashboardActionTypes.STUDENTS_TAGS_PIN_SUCCESS: {
      const studentNumbers = action.payload.studentsNumbers;
      return {
        ...state,
        students: state.students?.map(student => {
          if (studentNumbers.includes(student.p_key)) {
            const tagIds = student?.tags?.map(tag => tag.id) || [];
            const updatedTags: ITag[] = action.payload.tags;
            const tags: ITag[] = [...student.tags, ...updatedTags.filter(tag => !tagIds.includes(tag.id))];
            return { ...student, tags };
          }
          return student;
        }),
      };
    }

    case DashboardActionTypes.OPEN_STUDENT_RECORDS: {
      return {
        ...state,
        openedStudentRecords: action.payload,
      };
    }

    case DashboardActionTypes.STUDENT_STATUS_CHANGE: {
      return {
        ...state,
        resetDropdownStatus: false,
        isDropdownDisabled: false,
        students: state.students?.map(student => {
          if (action.payload.studentId === student.p_key) {
            // @ts-ignore
            student.status = action.payload.status ?? ApplicantOfferStatus.Applied;
          }
          return student;
        }),
        selectedRows: [],
      };
    }

    case DashboardActionTypes.MULTI_TRANSITION_STATUS: {
      return {
        ...state,
        resetDropdownStatus: false,
        isDropdownDisabled: false,
      };
    }

    case DashboardActionTypes.MULTI_TRANSITION_STATUS_SUCCESS: {
      const newStudents = [...state.students!];
      const newTotals = [...state.totals];
      for (const id of action.payload.studentIDs) {
        const index = newStudents.findIndex(doc => doc.p_key === id);
        const newTotalStatusIndex = newTotals.findIndex(t => t.casStatus === action.payload.status);
        const oldTotalStatusIndex = newTotals.findIndex(t => t.casStatus === newStudents[index].status);
        if (index > -1 && oldTotalStatusIndex > -1) {
          newStudents.splice(index, 1);

          newTotals[oldTotalStatusIndex].total -= 1;

          if (newTotalStatusIndex < 0) {
            newTotals.push({ casStatus: action.payload.status, total: 1 });
          } else {
            newTotals[newTotalStatusIndex].total += 1;
          }
        }
      }

      return {
        ...state,
        resetDropdownStatus: true,
        isDropdownDisabled: true,
        students: newStudents,
        totals: newTotals,
        selectedRows: [],
      };
    }

    case DashboardActionTypes.MULTI_TRANSITION_STATUS_FAILURE: {
      return {
        ...state,
        resetDropdownStatus: true,
        isDropdownDisabled: true,
      };
    }

    case DashboardActionTypes.SET_FILTERS: {
      return {
        ...state,
        filters: action.payload.filters,
      };
    }
    case DashboardActionTypes.SET_SORT: {
      return {
        ...state,
        sort: action.payload,
      };
    }

    case DashboardActionTypes.SET_FILTERS_VISIBLE: {
      return {
        ...state,
        isFiltersVisible: action.payload.isFiltersVisible,
      };
    }

    case DashboardActionTypes.SET_SELECTED_ROWS: {
      return {
        ...state,
        selectedRows: action.payload.selectedRows,
        allSelected: false,
      };
    }

    case DashboardActionTypes.SET_IS_TASKBAR_OPEN: {
      return {
        ...state,
        isTaskBarOpened: action.payload.isOpen,
      };
    }

    case DashboardActionTypes.SET_IS_DROPDOWN_DISABLED: {
      return {
        ...state,
        isDropdownDisabled: action.payload.isDisabled,
      };
    }

    case DashboardActionTypes.SET_TABS: {
      return {
        ...state,
        tabs: action.payload.tabs,
        allSelected: false,
      };
    }

    case UIActionTypes.SET_HEADER_TAB: {
      return { ...state, selectedRows: [], isDropdownDisabled: true };
    }

    case DashboardActionTypes.CANCEL_RECORDED_INTERVIEW_SUCCESS: {
      toast.success(`Successfully cancelled a recorded interview`);
      return {
        ...state,
        selectedRows: [],
      };
    }
    case DashboardActionTypes.CANCEL_RECORDED_INTERVIEW_BULK_SUCCESS: {
      toast.success(`Successfully cancelled recorded interview(s)`);
      return {
        ...state,
        selectedRows: [],
      };
    }
    case DashboardActionTypes.CANCEL_RECORDED_INTERVIEW_FAILURE: {
      toast.error(`Failed to cancel a recorded interview: ${action.payload}`);
      return state;
    }
    case DashboardActionTypes.CANCEL_RECORDED_INTERVIEW_BULK_FAILURE: {
      toast.error(`Failed to cancel recorded interviews:`);
      return state;
    }
    case DashboardActionTypes.GET_FILTERS: {
      return { ...state, filterOptionsLoading: true };
    }
    case DashboardActionTypes.BULK_ACTION_FAILURE: {
      toast.error(`Failed to do a bulk action: ${action.payload}`);
      return state;
    }

    case DashboardActionTypes.GET_FILTERS_SUCCESS: {
      return { ...state, filterOptions: action.payload, filterOptionsLoading: false };
    }

    case DashboardActionTypes.GET_FILTERS_FAILURE: {
      return { ...state, filterOptionsLoading: false };
    }

    case DashboardActionTypes.SELECT_ALL: {
      return { ...state, allSelected: action.payload };
    }
    case DashboardActionTypes.BULK_ACTION: {
      const { isPartner, studentNumbers, data, bulkActionType } = action.payload;
      if (isPartner && state.students) {
        const [selectedStudentNumber] = studentNumbers;
        const [partner] = data;
        const index = state.students.findIndex(doc => doc.p_key === selectedStudentNumber);
        if (index > -1) {
          return {
            ...state,
            students: updateStudentPartners(state.students, index, bulkActionType, partner),
          };
        }
      }
      return state;
    }

    case DashboardActionTypes.GET_SELECTED_PARTNERS: {
      return {
        ...state,
        selectedPartnersLoading: true,
      };
    }
    case DashboardActionTypes.GET_SELECTED_PARTNERS_SUCCESS: {
      const { selectedPartnersTotals } = action.payload;
      return {
        ...state,
        selectedPartnersLoading: true,
        selectedPartnersTotals,
      };
    }
    case DashboardActionTypes.GET_SELECTED_PARTNERS_COMPLETE: {
      return {
        ...state,
        selectedPartnersLoading: false,
      };
    }
    case DashboardActionTypes.GET_SELECTED_PARTNERS_FAILURE: {
      return {
        ...state,
        selectedPartnersLoading: false,
      };
    }

    case DashboardActionTypes.GET_SELECTED_TAGS: {
      return {
        ...state,
        selectedTagsLoaded: true,
      };
    }
    case DashboardActionTypes.GET_SELECTED_TAGS_SUCCESS: {
      const { selectedTagsTotals } = action.payload;
      return {
        ...state,
        selectedTagsLoaded: true,
        selectedTagsTotals,
      };
    }
    case DashboardActionTypes.GET_SELECTED_TAGS_COMPLETE: {
      return {
        ...state,
        selectedTagsLoaded: false,
      };
    }
    case DashboardActionTypes.GET_SELECTED_TAGS_FAILURE: {
      return {
        ...state,
        selectedTagsLoaded: false,
      };
    }
    case DashboardActionTypes.TRIGGER_SITS_TRANSFER: {
      return {
        ...state,
        selectedTagsLoaded: false,
      };
    }
    case DashboardActionTypes.TRIGGER_SITS_TRANSFER_SUCCESS: {
      return {
        ...state,
        sitsTransferResponse: action.payload,
      };
    }
    case DashboardActionTypes.TRIGGER_SITS_TRANSFER_FAILURE: {
      return {
        ...state,
      };
    }

    default:
      return state;
  }
};

export { reducer as dashboardReducer };
